import { Formik } from "formik";
import { Modal } from "../../../components/common/Modal/Modal";
import { ModalBody } from "../../../components/common/Modal/ModalBody";
import { ModalFooter } from "../../../components/common/Modal/ModalFooter";
import { ModalHeader } from "../../../components/common/Modal/ModalHeader";
import { useSaleChannelStore } from "../../../hooks/useSaleChannelStore"
import { useState, useEffect } from "react";
import { Grid, FormLabel, TextField, Divider } from '@mui/material';

type Values = {
    id: number
    name: string
}

export const SalesChannelsModal:React.FC<any> = (props): JSX.Element | any => {
    const { open, closeModal, onList } = props

    const { action, editSaleChannel, createSaleChannel, updateSaleChannel } = useSaleChannelStore()

    const [data, setData] = useState<Values>({
        id: 0,
        name: '',
    })
    const [loading, setLoading] = useState(false)
    const [isEdit, setIsEdit] = useState<boolean>(false)

    useEffect(() => {
        setDataEdit()
    }, [])

    const setDataEdit = () => {
        if (Object.entries(editSaleChannel).length > 0) {
            setIsEdit(true)
            setData({
                id: editSaleChannel.id,
                name: editSaleChannel.name
            })
        }
    }

    const validateForm = (values) => {
        let errors:any = {};
        if(!values.name) errors.name = "el campo es requerido";
        return errors;
    }

    const onSubmit = async (values) => {
        const payload = {
            name: values.name
        }
        setLoading(true)
        const response = await (!isEdit ? createSaleChannel(payload) : updateSaleChannel(editSaleChannel.id, payload))
        if (response === true) {
            onList()
            closeModal()
        }
        setLoading(false)
    }

    return (
        <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick handle size="md" paperprops={{style: { position: 'absolute', right: -30, borderRadius: 20, animation: 'slide-in 0.3s ease-out', maxHeight: '100%', height: '100vh' }}}>
            <ModalHeader
                text={action === 'detail' ? 'Detalle del canal de venta ' : ( isEdit ? 'Editar canal de venta' : 'Nuevo canal de venta')}
                className='positionElements'
                onCancel={closeModal}
            />
            <ModalBody>
                <Formik initialValues={data} enableReinitialize validate={ (values) => validateForm(values) } onSubmit={onSubmit}>
                    {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) => {
                        return (
                            <form onSubmit={handleSubmit}>
                                <Grid container sx={{padding:'20px'}}>
                                    <Grid item container xs={12} spacing={2}>
                                        <Grid item xs={12}>
                                            <FormLabel>Nombre del canal de venta:</FormLabel>
                                            <TextField
                                                id="name"
                                                type="text" 
                                                name="name"
                                                fullWidth
                                                size="small"
                                                value={values.name}
                                                onChange={handleChange}
                                                error={errors.name && touched.name ? true : false}
                                                helperText={errors.name && touched.name ? errors.name : ''}
                                                InputProps={{
                                                    readOnly: action === 'detail',
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Divider />
                                {
                                    action !== 'detail' && 
                                        <ModalFooter 
                                            buttonType="submit"
                                            confirmText={'Guardar'}
                                            onConfirm={handleSubmit}
                                            cancelText={"Cancelar"}
                                            onCancel={closeModal}
                                            loadingConfirmText={loading}
                                        />
                                }
                            </form>
                        )
                    }} 
                </Formik>
            </ModalBody>
        </Modal>
    )
}